import { EFiltersActionTypes } from '../../actions/filters/types';
import { DEFAULT_REGION_FILTER } from '../../constants/currentRegion';
import { IFiltersState } from '../../types/filters';
import { TReduxActions } from '../../types/redux';

export const defaultState: IFiltersState = {
  type: 'all',
  date: '2023-01-01',
  region: DEFAULT_REGION_FILTER,
};

export const filtersReducer = (state: IFiltersState = defaultState, action: TReduxActions) => {
  switch (action.type) {
    case EFiltersActionTypes.SetRatingType:
      return { ...state, type: action.payload };
    case EFiltersActionTypes.SetCurrentDate:
      return { ...state, date: action.payload };
    case EFiltersActionTypes.SetRegion:
      return { ...state, region: action.payload };
    default:
      return state;
  }
};
